import { createContext, useContext, useEffect, useState } from 'react';
import { getCurrentLifeEvent, getFingertipsLinks } from '../services/dashboard';
import {
  getActiveHealthBenefits,
  getActiveLifeAndDisabilityInsurances,
  getActiveSpendingAccounts,
  getActiveLifestyleBenefits,
} from '../services/enrollment';
import { AuthStore } from './auth';

export type PaymentInformationState = {
  activeHealthBenefits: Array<any>;
  activeSpendingAccounts: Array<any>;
  activeLifeAndDisabilityInsurances: Array<any>;
  activeLifestyleBenefits: Array<any>;
  fingertipLinks: Array<any>;
  currentLifeEvent: any;
  currentPersona?: any;
};

export const PaymentInformationStore = createContext<PaymentInformationState>({
  activeHealthBenefits: [],
  activeSpendingAccounts: [],
  activeLifeAndDisabilityInsurances: [],
  activeLifestyleBenefits: [],
  fingertipLinks: [],
  currentLifeEvent: undefined,
  currentPersona: '',
});

const { Provider } = PaymentInformationStore;

export const PaymentInformationProvider = ({ children }: any) => {
  const [, , , selectedPersona] = useContext(AuthStore) || [];
  const [paymentInformationState, setPaymentInformationState] =
    useState<PaymentInformationState>({
      activeHealthBenefits: [],
      activeSpendingAccounts: [],
      activeLifeAndDisabilityInsurances: [],
      activeLifestyleBenefits: [],
      fingertipLinks: [],
      currentLifeEvent: {},
      currentPersona: '',
    });

  useEffect(() => {
    let activeHealthBenefits = getActiveHealthBenefits();
    let activeSpendingAccounts = getActiveSpendingAccounts();
    let activeLifeAndDisabilityInsurances =
      getActiveLifeAndDisabilityInsurances();
    let activeLifestyleBenefits = getActiveLifestyleBenefits();
    let fingertipLinks = getFingertipsLinks(selectedPersona);
    let currentLifeEvent = getCurrentLifeEvent();

    setPaymentInformationState({
      activeHealthBenefits,
      activeSpendingAccounts,
      activeLifeAndDisabilityInsurances,
      activeLifestyleBenefits,
      currentLifeEvent,
      fingertipLinks,
      currentPersona: selectedPersona,
    });
  }, [selectedPersona]);

  return <Provider value={paymentInformationState}>{children}</Provider>;
};
